<svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="m15.757 19.322-.494.507a.523.523 0 0 1-.755 0l-4.33-4.438a.556.556 0 0 1 0-.774l4.33-4.441a.523.523 0 0 1 .755 0l.494.507a.559.559 0 0 1-.009.784l-2.683 2.622h6.4a.54.54 0 0 1 .535.548v.731a.54.54 0 0 1-.535.548h-6.4l2.683 2.623a.555.555 0 0 1 .01.783z" id="5jw9aq9hba"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <circle stroke="currentColor" stroke-width="1.875" cx="15" cy="15" r="14.063"/>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#5jw9aq9hba"/>
    </g>
</svg>
